import { NoteBlock } from "../block";

export interface CronBlock extends NoteBlock {
  type: "omega/query-omega/page/block/cron/CronBlock";
  "cron-id": string;
  name?: string;
  schedule?: string;
  "subscription-page-id"?: string;
  "subscription-name"?: string;
  "sub-id"?: string;
}

export function isCronBlock(block: NoteBlock): block is CronBlock {
  return (block as CronBlock)["cron-id"] !== undefined;
}
